import { Link } from "react-router-dom";

export const Logo = ({ light = false, testid = "logo-link" }) => (
  <Link to="/" data-testid={testid} aria-label="livemedia.az — əsas səhifə" className="flex items-center gap-3">
    <span className={`logo-mark ${light ? "light" : ""}`} aria-hidden="true" />
    <span className={`font-display text-[22px] font-bold tracking-tight ${light ? "text-[#F7F3EB]" : "text-[#171715]"}`}>livemedia.az</span>
  </Link>
);
